"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Revenue = void 0;
var Revenue = (function () {
    function Revenue() {
    }
    Revenue.getAttributeTypeMap = function () {
        return Revenue.attributeTypeMap;
    };
    Revenue.discriminator = undefined;
    Revenue.attributeTypeMap = [
        {
            "name": "month",
            "baseName": "month",
            "type": "string",
            "format": ""
        },
        {
            "name": "rewardAmount",
            "baseName": "reward_amount",
            "type": "number",
            "format": ""
        },
        {
            "name": "paymentAmount",
            "baseName": "payment_amount",
            "type": "number",
            "format": ""
        },
        {
            "name": "carryOveredRewardAmount",
            "baseName": "carry_overed_reward_amount",
            "type": "number",
            "format": ""
        },
        {
            "name": "withholdingTaxAmount",
            "baseName": "withholding_tax_amount",
            "type": "number",
            "format": ""
        },
        {
            "name": "commissionAmount",
            "baseName": "commission_amount",
            "type": "number",
            "format": ""
        },
        {
            "name": "thisMonthRevenues",
            "baseName": "this_month_revenues",
            "type": "Array<RevenueThisMonthRevenues>",
            "format": ""
        },
        {
            "name": "thisMonthRewardAmount",
            "baseName": "this_month_reward_amount",
            "type": "number",
            "format": ""
        },
        {
            "name": "lastMonthCarryOveredRevenues",
            "baseName": "last_month_carry_overed_revenues",
            "type": "Array<RevenueLastMonthCarryOveredRevenues>",
            "format": ""
        },
        {
            "name": "lastMonthCarryOveredRewardAmount",
            "baseName": "last_month_carry_overed_reward_amount",
            "type": "number",
            "format": ""
        },
        {
            "name": "thisMonthCarryOveredReward",
            "baseName": "this_month_carry_overed_reward",
            "type": "number",
            "format": ""
        },
        {
            "name": "isGroupPayment",
            "baseName": "is_group_payment",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isGroupPaymentParent",
            "baseName": "is_group_payment_parent",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "existenceFlag",
            "baseName": "existence_flag",
            "type": "boolean",
            "format": ""
        }
    ];
    return Revenue;
}());
exports.Revenue = Revenue;
//# sourceMappingURL=Revenue.js.map